module.exports = __webpack_public_path__ + "static/media/Trailer.978599c8.svg";